import assistence from './assistance'

export default [
  ...assistence,
]
